import type { InitOptions } from "i18next";
import type commandMenu from "./locales/da/command-menu.json";
import type common from "./locales/da/common.json";
import type createLead from "./locales/da/create-lead.json";
import type danishCondition from "./locales/da/danish-condition.json";
import type danishElectric from "./locales/da/danish-electric.json";
import type editing from "./locales/da/editing.json";
import type forgotPassword from "./locales/da/forgot-password.json";
import type homesGlossary from "./locales/da/homes-glossary.json";
import type leadDetails from "./locales/da/lead-details.json";
import type leadsGlossary from "./locales/da/leads-glossary.json";
import type leadsOverview from "./locales/da/leads-overview.json";
import type login from "./locales/da/login.json";
import type materialCatalog from "./locales/da/material-catalog.json";
import type navigation from "./locales/da/navigation.json";
import type resetPassword from "./locales/da/reset-password.json";
import type settings from "./locales/da/settings.json";
import type signup from "./locales/da/signup.json";
import type validation from "./locales/da/validation.json";
import type verifyEmail from "./locales/da/verify-email.json";

export type SupportedLocale = "da" | "en" | "de" | "fr";
export const supportedLocales = ["da", "en", "de", "fr"] as const;

export const i18nextInitOptions: InitOptions = {
	supportedLngs: supportedLocales,
	fallbackLng: "en",
	lowerCaseLng: true,
	defaultNS: "common",
	react: {
		useSuspense: false,
	},
};

declare module "i18next" {
	interface CustomTypeOptions {
		defaultNS: "common";
		resources: {
			"command-menu": typeof commandMenu;
			"create-lead": typeof createLead;
			"danish-condition": typeof danishCondition;
			"danish-electric": typeof danishElectric;
			"forgot-password": typeof forgotPassword;
			"homes-glossary": typeof homesGlossary;
			"lead-details": typeof leadDetails;
			"leads-glossary": typeof leadsGlossary;
			"leads-overview": typeof leadsOverview;
			"material-catalog": typeof materialCatalog;
			"reset-password": typeof resetPassword;
			"verify-email": typeof verifyEmail;
			common: typeof common;
			editing: typeof editing;
			login: typeof login;
			navigation: typeof navigation;
			settings: typeof settings;
			signup: typeof signup;
			validation: typeof validation;
		};
	}
}
